export default __webpack_public_path__ + "static/media/caffeShopn.75a826fb.jpg";